/**
 * Perceived-glass tokens — extracted from EDITOR_TOP_BAR_SURFACE_SX and
 * EDITOR_BOTTOM_PILL in UploadFloor.js. No backdrop-filter on by default;
 * the shipped recipe achieves the liquid-glass look via opaque-ish fill,
 * specular white rim, layered drop shadow, and inset highlights.
 */
export const glass = {
  /** Top bar / panel fill — from EDITOR_TOP_BAR_SURFACE_SX. */
  background: "rgba(248, 248, 250, 0.97)",
  /** FAB / pill fill — slightly brighter, from EDITOR_BOTTOM_PILL. */
  backgroundElevated: "rgba(252, 252, 255, 0.98)",
  /** Solid white for the high-emphasis shuffle FAB primary state. */
  backgroundSolid: "#FFFFFF",
  /** Specular white rim — shared by top bar + bottom pill + filter chip idle. */
  border: "1px solid rgba(255, 255, 255, 0.72)",
  /** Explicitly disabled — perceived glass intentionally avoids GPU blur. */
  backdropFilter: "none",
  WebkitBackdropFilter: "none",
  /** EDITOR_TOP_BAR_SURFACE_SX shadow stack (cool drop + close diffuse + insets). */
  shadowTopBar: [
    "0 6px 18px rgba(13, 40, 71, 0.10)",
    "0 1px 4px rgba(0, 0, 0, 0.05)",
    "inset 0 1px 0 rgba(255, 255, 255, 0.85)",
    "inset 0 -1px 0 rgba(255, 255, 255, 0.15)",
  ].join(", "),
  /** EDITOR_BOTTOM_PILL shadow stack (heavier specular for pill). */
  shadowPill: [
    "0 6px 18px rgba(13, 40, 71, 0.10)",
    "0 1px 4px rgba(0, 0, 0, 0.05)",
    "inset 0 1.5px 0 rgba(255, 255, 255, 0.95)",
    "inset 0 -1px 0 rgba(255, 255, 255, 0.20)",
  ].join(", "),
  /**
   * Glass FAB shadow stack — extracted from the four FAB call sites in
   * UploadFloor.js (Add Items, Shuffle saveIsPrimary branch, Save/Share,
   * Inquire). Replaces the literal-blur recipe so all FABs share one
   * perceived-glass surface without backdrop-filter.
   */
  shadowFab: [
    "0 4px 16px rgba(13, 40, 71, 0.10)",
    "0 1px 4px rgba(0, 0, 0, 0.05)",
    "inset 0 1.5px 0 rgba(255, 255, 255, 0.95)",
  ].join(", "),
  /**
   * Solid-white shuffle FAB shadow stack — when saveIsPrimary === false,
   * Shuffle is the hero CTA and uses a heavier shadow over solid white.
   * Extracted from UploadFloor.js shuffle button (~15980).
   */
  shadowElevatedFab: [
    "0 10px 32px rgba(0, 0, 0, 0.24)",
    "0 2px 8px rgba(0, 0, 0, 0.12)",
    "inset 0 1.5px 0 rgba(255, 255, 255, 0.90)",
  ].join(", "),
  /** galleryChipGlassSx idle shadow (LayoutVersionSlider.js ~289). */
  shadowChipIdle:
    "0 0 5px rgba(0, 0, 0, 0.07), 0 2px 5px rgba(0, 0, 0, 0.06)",
  /** galleryChipGlassActiveSx shadow (LayoutVersionSlider.js ~295). */
  shadowChipActive:
    "0 0 6px rgba(0, 0, 0, 0.08), 0 2px 6px rgba(0, 0, 0, 0.07)",
  /** Editor filter chip selected shadow — neutralized from brand customShadows[1]. */
  shadowFilterChipSelected: [
    "0 4px 14px rgba(13, 40, 71, 0.12)",
    "inset 0 1px 0 rgba(255, 255, 255, 0.95)",
  ].join(", "),
  /** Editor filter chip idle shadow (UploadFloor.js getEditorFilterChipSx). */
  shadowFilterChipIdle: [
    "0 2px 8px rgba(13, 40, 71, 0.06)",
    "0 1px 2px rgba(0, 0, 0, 0.04)",
    "inset 0 1px 0 rgba(255, 255, 255, 0.95)",
  ].join(", "),
};
